/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select } from "rbx";

import { ALL_GL_MAIN_ACCOUNTS_QUERY } from "../../graphql/GLMainAccounts/GLMainAccounts.graphql";

const GLMainAccountSelect = ({
  value,
  label,
  size,
  name,
  onChange,
  disabled,
  where,
  tabIndex
}) => {
  const { data, loading, error } = useQuery(ALL_GL_MAIN_ACCOUNTS_QUERY, {
    variables: {
      where,
      orderByMulti: ["MainAccountId_ASC", "Description_ASC"]
    }
  });
  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control size={size}>
        <Select.Container
          fullwidth
          color={error ? "danger" : ""}
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select
            disabled={disabled}
            name={name}
            tabIndex={tabIndex}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="">Select...</Select.Option>
            {!loading &&
              data.GLMainAccounts?.map((item, i) => (
                <Select.Option
                  key={`gl-main-account-select-${i}`}
                  value={item.RecId}
                >
                  {`${item.MainAccountId} - ${item.Description}`}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
      </Control>
    </Field>
  );
};

GLMainAccountSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  where: PropTypes.object,
  tabIndex: PropTypes.string
};
export default GLMainAccountSelect;
